import React from 'react'

const OptionsComponent = ({className,option, index, icon, selectedOption, onClickOption, width = "w-max"}) => {

  const checkSelected = () => {
    if(Array.isArray(selectedOption)){
      return selectedOption.includes(option.value);
    }
    return selectedOption === option.value;
  }
  return (
    <div key={index} className={`onBoarding-description flex justify-start items-center ${width} gap-2
    bg-[#fff] rounded-[8px] px-[16px] py-[24px] cursor-pointer hover:border-[#12ABBF] 
    ${checkSelected() ? 'border-[#12ABBF] border-[2px]' : 'border-[#E6E7E9] border-[1px]'} ${className}`} onClick={() => onClickOption(option)}>
        {icon ? 
        <img src={icon} alt={""} className='w-[24px] h-[24px]'/> : ""}
        {option.value}
    </div>
  )
}

export default OptionsComponent